import { useEffect, useState } from "react";
import { useDashboardDomainContext } from "../DashboardDomainProvider";
import DashboardHeader from '../components/DashboardHeader/DashboardHeader';
import { VisualGrid } from '../components/VisualGrid/VisualGrid';
import NavigationRibbon from '../components/NavigationRibbon/NavigationRibbon';
import { Loading } from "./Loading";
import './Dashboard.scss';
import { LoadingScreen } from "../components/LoadingScreen";
import { ErrorMessage } from "../components/VisualGrid/messages/ErrorMessage";

const Dashboard = () => {
  const { isDashboardLoading, selectedDashboardId, dashboardLib } = useDashboardDomainContext();
  const hasError = !!dashboardLib?.hasError;
  const [hasCompletedInitialLoad, setHasCompletedInitialLoad] = useState(false);

  useEffect(() => {
    setHasCompletedInitialLoad(false);
  }, [selectedDashboardId]);

  useEffect(() => {
    if (selectedDashboardId && !isDashboardLoading) {
      setHasCompletedInitialLoad(true);
    }
  }, [isDashboardLoading, selectedDashboardId]);

  const showStartupLoader = !!selectedDashboardId && isDashboardLoading && !hasCompletedInitialLoad;

  return (
    <div className="dashboard-container">
      <LoadingScreen isLoading={showStartupLoader} fadeIn={false}>
        <Loading />
      </LoadingScreen>

      {hasError ? (
        <ErrorMessage />
      ) : (
        <>
          <DashboardHeader />
          <VisualGrid />
          <NavigationRibbon />
        </>
      )}
    </div>
  );
};

export default Dashboard;
